<template>
	<div id="search-container" class="">
		<div class="search-query-wr" v-if="available">
			<p>
				{{ searchResultFirst }}<span class="search-query">{{ query }}</span>{{ searchResultSecond }}
				<span class="search-query-num">{{ totalItemsCount }}</span>{{ searchResultThird }}
			</p>
		</div>

		<div class="search-results" v-bind:style="{ 'display': ( available ? 'block' : 'none') }">
			<ul class="search-results-wr">
				<li class="search-results-theme" v-for="(category, categoryIndex) in page" :key="category.category + categoryIndex">
					<p class="search-results-theme-title">{{ category.category }} ({{ category.totalItemsCount }})</p>

					<ul class="search-results-theme-list">
						<li class="search-results-theme-item" v-for="(item, index) in category.searchResult" :key="index">
							<a :href="item.urlCode" v-html="item.title" @click="gaEvent(query, item.title)"></a>
						</li>
					</ul>
				</li>
			</ul>

			<div class="pagination" v-if="totalPages > 1">
				<button type="button" class="arrow-btn arrow-btn-prev" :disabled="activePage == 1" @click="changePage(prevPage)" onclick="ga('send', 'event', 'search_apply', 'page_arrow_click', 'left');">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="22" viewBox="0 0 14 22"><defs><path id="t66ka" d="M998.29 3133.4l-10.6 10.6 10.6 10.6 2.12-2.11-8.48-8.49 8.48-8.49z"></path></defs><g><g transform="translate(-987 -3133)"><use xlink:href="#t66ka"></use></g></g></svg>
				</button>
				
				<ul class="pagination-num">
					<li class="pagination-num-item" v-if="hasFirst()">
						<a href="#" class="inner" @click.prevent="changePage(1)">1</a>
					</li>
					<li class="pagination-num-item" v-if="hasFirst()">...</li>

					<li class="pagination-num-item" :class="{ 'active': activePage == page}" v-for="page in pages" :key="'page_' + page">
						<a href="#" class="inner" @click.prevent="changePage(page)">
							{{ page }}
						</a>
					</li>

					<li class="pagination-num-item" v-if="hasLast()">...</li>
					<li class="pagination-num-item" v-if="hasLast()">
						<a href="#" class="inner" @click.prevent="changePage(totalPages)">
							{{ totalPages }}
						</a>
					</li>
				</ul>

				<button type="button" class="arrow-btn arrow-btn-next" :disabled="activePage == totalPages" @click="changePage(nextPage)" onclick="ga('send', 'event', 'search_apply', 'page_arrow_click', 'right');">
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="22" viewBox="0 0 14 22"><defs><path id="5afoa" d="M1066.71 3154.6l10.6-10.6-10.6-10.6-2.12 2.11 8.48 8.49-8.48 8.49z"></path></defs><g><g transform="translate(-1065 -3133)"><use xlink:href="#5afoa"></use></g></g></svg>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import groupBy from "lodash.groupBy";
	import Pagination from "../Pagination.vue";
	import { mapGetters } from "vuex";

	export default {
		props: ["available", "searchResultFirst", "searchResultSecond", "searchResultThird"],
		components: {
			Pagination
		},
		data() {
			return {
				query: '',
				activePage: 1,
				totalItemsCount: 0,
				itemsToShow: 10,
				pageRange: 2
			};
		},
		computed: {
			...mapGetters(["searchQuery", "searchResult"]),
			
			categories() {
				let result = {};
				if (this.searchResult) {
					this.searchResult.categories.map(c => {
						const { category, totalItemsCount } = c;
						result[category] = { category, totalItemsCount };
					});
				}
				return result;
			},
			list() {
				if (this.searchResult) {
					return this.searchResult.categories.reduce(
						(result, el) => result.concat(el.searchResult), []
					);
				}
				return [];
			},
			page() {
				const sIndex = this.itemsToShow * (this.activePage - 1);
				const page = groupBy(this.list.slice(sIndex, sIndex + this.itemsToShow), "category");
				let result = {};
				Object.keys(page).map(key => {
					result[key] = {
						category: key,
						totalItemsCount: this.categories[key].totalItemsCount,
						searchResult: page[key]
					};
				});
				return result;
			},
			pages() {
				var pages = []

				for(var i = this.rangeStart; i <= this.rangeEnd; i++) {
					pages.push(i)
				}

				return pages
			},
			rangeStart() {
				var start = this.activePage - this.pageRange

				return (start > 0) ? start : 1
			},
			rangeEnd() {
				var end = this.activePage + this.pageRange

				return (end < this.totalPages) ? end : this.totalPages
			},
			totalPages() {
				return Math.ceil(this.totalItemsCount / this.itemsToShow);
			},
			nextPage() {
				return this.activePage + 1;
			},
			prevPage() {
				return this.activePage - 1;
			}
		},
		watch: {
			searchResult() {
				this.query = this.searchQuery;
				this.activePage = 1;
				this.totalItemsCount = this.searchResult.categories.reduce(
					(total, el) => total + el.totalItemsCount, 0
				);
			}
		},
		methods: {
			hasFirst() {
				return this.rangeStart !== 1
			},
			hasLast() {
				return this.rangeEnd < this.totalPages
			},
			changePage(page) {
				this.activePage = page;
				ga('send', 'event', 'search_apply', 'page_number_click', page);
			},
			gaEvent(query, title) {
				ga('send', 'event', 'search_apply', query, title);
			}
		}
	};
</script>
